.nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  min-width: 0;
  overflow: hidden;
}

.link {
  display: flex;
  align-items: center;
  margin-right: 8px;
  font-weight: 300;
  text-decoration: none;
  cursor: pointer;
  color: inherit;
  font-size: var(--tuna-typography-fontSize-md);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
}

.inactiveLink {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.homeLink {
  display: flex;
  align-items: center;
  margin-right: 0;
  font-weight: 300;
  text-decoration: none;
  cursor: pointer;
  color: var(--tuna-palette-action-disabled);
}

.separator {
  color: var(--tuna-palette-text-secondary);
  margin: 0 4px;
}

.iconWrapper {
  margin-right: 4px;
}

.ellipsis {
  cursor: pointer;
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-md);
  padding: 0 2px;
}

.ellipsis:hover {
  color: var(--tuna-palette-text-primary);
}
